import { AnimatePresence, motion } from "framer-motion";
import { RecentDocument, RequiredItem } from "v2/store/entityDocumentsApi";
import { SCROLL_HINT_VARIANT, ScrollListHint } from "./ScrollListHint";
import { SupportingDocumentsList } from "./SupportingDocumentsList";
import { UnmatchedDocumentsPanel } from "./UnmatchedDocumentsPanel";
import { useScrollListHint } from "./useScrollListHint";

type SupportingDocumentsPanelProps = {
  entityId: string;
  items: RequiredItem[];
  matchedIds: Set<string>;
  uploaded: RecentDocument[];
  unmatchedCount: number;
};

export const SupportingDocumentsPanel = ({
  entityId,
  items,
  matchedIds,
  uploaded,
  unmatchedCount,
}: SupportingDocumentsPanelProps) => {
  const rowCount = items.length + uploaded.length + unmatchedCount;

  const {
    ref: listRef,
    showHint: showScrollHint,
    onScroll: updateScrollHint,
    scrollDown: handleScrollDown,
  } = useScrollListHint<HTMLDivElement>(rowCount);

  return (
    <div className="t-relative">
      <div
        ref={listRef}
        onScroll={updateScrollHint}
        className="t-flex t-max-h-52 t-flex-col t-gap-3 t-overflow-y-auto t-pb-4"
      >
        <SupportingDocumentsList
          entityId={entityId}
          items={items}
          matchedIds={matchedIds}
          uploaded={uploaded}
        />

        {unmatchedCount > 0 && (
          <UnmatchedDocumentsPanel entityId={entityId} count={unmatchedCount} />
        )}
      </div>

      <AnimatePresence>
        {showScrollHint && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <ScrollListHint
              variant={SCROLL_HINT_VARIANT.COMPACT}
              onClick={handleScrollDown}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
